export default __webpack_public_path__ + "static/media/twitter.891e6201.svg";